import { isStudioModuleEntitled } from "./studioModules";

export const isCatalogueEnabled = (): boolean =>
  process.env.REACT_APP_CATALOGUE_ENABLED !== "false";

export const canUseCatalogue = (role?: string): boolean => {
  if (!isCatalogueEnabled() || !role) {
    return false;
  }
  if (role !== "ORGANIZATION_ADMIN" && role !== "ORGANIZATION_MANAGER") {
    return false;
  }
  return isStudioModuleEntitled("CATALOGUE");
};
